export default "__VITE_ASSET__BT83ORPi__"